import { NavigationIcon } from '../../types';
import { ICON_MAPPINGS } from '../constants/icon-mappings';

export function mapIdToIcon(id: string): NavigationIcon {
  const idLower = id.toLowerCase();

  for (const [key, icon] of Object.entries(ICON_MAPPINGS)) {
    if (idLower === key) {
      return icon as NavigationIcon;
    }
  }

  return 'page';
}
